import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "prod-offer" };
const _hoisted_2 = { class: "prod-offer__wrap" };
const _hoisted_3 = { class: "prod-offer__block" };
import FilterSelector from "./FilterSelector.vue";
import { computed, inject, ref, watch } from "vue";
import OfferPrice from "./OfferPrice.vue";
import PreOrder from "./PreOrder.vue";
import HintTooltip from "./HintTooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferSelector',
    props: {
        product: { type: Object, required: true },
        types: { type: Array, required: true },
        hintTeleport: Object,
    },
    setup(__props) {
        const props = __props;
        const activeType = inject('type');
        const isGiftSet = computed(() => activeType.value.name === 'Набор');
        const activeFilter = ref();
        const offerModel = inject('offer');
        const offersByType = computed(() => props.product.offers.filter(offer => { var _a; return offer.type === ((_a = activeType.value) === null || _a === void 0 ? void 0 : _a.id); }));
        const filters = computed(() => offersByType.value.map(offer => ({
            name: offer.volume ? `${offer.volume} мл` : offer.title,
            volume: offer.volume,
            flag: offer.distinction.join(', '),
            disabled: !offer.active,
        })));
        if (offerModel.value) {
            activeType.value = props.types.find(t => t.id === offerModel.value.type);
            if (offersByType.value.find(o => offerModel.value.id === o.id)) {
                activeFilter.value = filters.value.find(filter => {
                    if (isGiftSet.value) {
                        return offerModel.value.title === filter.name;
                    }
                    return offerModel.value.volume === filter.volume && offerModel.value.distinction.join(', ') === filter.flag;
                });
            }
            else {
                offerModel.value = null;
            }
        }
        const filtersTitle = computed(() => isGiftSet.value ? 'Набор' : 'Объём');
        const offer = computed(() => {
            return offersByType.value.find(offer => {
                var _a, _b, _c;
                if (isGiftSet.value) {
                    return offer.title === ((_a = activeFilter.value) === null || _a === void 0 ? void 0 : _a.name);
                }
                return offer.volume === ((_b = activeFilter.value) === null || _b === void 0 ? void 0 : _b.volume) && offer.distinction.join(', ') === ((_c = activeFilter.value) === null || _c === void 0 ? void 0 : _c.flag);
            });
        });
        const hintButtonMessage = computed(() => {
            const flags = [];
            if (!offer.value) {
                return '';
            }
            if (offer.value.tester) {
                flags.push('тестер');
            }
            if (offer.value.sample) {
                flags.push('сэмпл');
            }
            if (offer.value.refill) {
                flags.push('refill');
            }
            return `Что такое ${flags.join('/')}?`;
        });
        if (!activeType.value) {
            activeType.value = props.types[0];
        }
        watch(offer, value => offerModel.value = value);
        if (offer.value) {
            offerModel.value = offer.value;
        }
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(FilterSelector, {
                        title: "Тип",
                        name: "product_type",
                        items: __props.types,
                        modelValue: _unref(activeType),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(activeType) ? (activeType).value = $event : null))
                    }, null, 8 /* PROPS */, ["items", "modelValue"]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (!((_a = _unref(activeType)) === null || _a === void 0 ? void 0 : _a.disabled))
                        ? (_openBlock(), _createBlock(FilterSelector, {
                            key: 0,
                            title: filtersTitle.value,
                            name: "product_filter",
                            items: filters.value,
                            modelValue: activeFilter.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeFilter).value = $event))
                        }, {
                            default: _withCtx(() => [
                                (offer.value.tester || offer.value.refill || offer.value.sample)
                                    ? (_openBlock(), _createBlock(HintTooltip, {
                                        key: 0,
                                        message: hintButtonMessage.value,
                                        "class-prefix": "prod-offer__help",
                                        refill: offer.value.refill,
                                        tester: offer.value.tester,
                                        sample: offer.value.sample,
                                        teleport: __props.hintTeleport
                                    }, null, 8 /* PROPS */, ["message", "refill", "tester", "sample", "teleport"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["title", "items", "modelValue"]))
                        : _createCommentVNode("v-if", true),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                        ((_b = offer.value) === null || _b === void 0 ? void 0 : _b.id)
                            ? (_openBlock(), _createBlock(OfferPrice, {
                                key: 0,
                                "product-id": __props.product.id,
                                offer: offer.value
                            }, null, 8 /* PROPS */, ["product-id", "offer"]))
                            : ((_c = _unref(activeType)) === null || _c === void 0 ? void 0 : _c.disabled)
                                ? (_openBlock(), _createBlock(PreOrder, {
                                    key: 1,
                                    "product-id": __props.product.id,
                                    type: _unref(activeType)
                                }, null, 8 /* PROPS */, ["product-id", "type"]))
                                : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
